import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { VisationService } from '../../core/services/visation.service';
import { Visation, VisationAction } from '../../core/models/visation.model';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { VisationModalComponent } from '../visation-modal/visation-modal.component';
import { VisationActionService } from '../../core/services/visation-action.service';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatSelectModule } from '@angular/material/select';
import { TableComponent } from '../../shared/components/table/table.component';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { TableColumn } from '../../core/models/column.model';

@Component({
  selector: 'app-approval-notification-detail',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    MatNativeDateModule,
    MatDatepickerModule,
    MatSelectModule,
    MatDialogModule,
    MatNativeDateModule,
    TableComponent,
    MatPaginatorModule,
    MatSortModule,
    MatTableModule,
  ],
  templateUrl: './approval-notification-detail.component.html',
  styleUrls: ['./approval-notification-detail.component.scss'],
})
export class ApprovalNotificationDetailComponent implements OnInit {
  visation!: Visation;

  flattenedActionsData: any[] = [];

  // Definir las columnas de la tabla
  tableColumns: TableColumn[] = [
    { header: 'Nº', field: 'id' },
    { header: 'Estado', field: 'actionName' }, // Estado de la acción
    { header: 'Comentario', field: 'observation' }, // Comentario
    { header: 'Fecha', field: 'date', isDate: true }, // Fecha de la acción
    // { header: 'Acciones', field: 'actions', template: 'actionTemplate' }  // Acciones con los botones
  ];

  constructor(
    private route: ActivatedRoute,
    private visationService: VisationService,
    private visationActionService: VisationActionService,
    private router: Router,
    public dialog: MatDialog,
  ) {}

  ngOnInit(): void {
    const id = +this.route.snapshot.paramMap.get('id')!;
    this.getVisation(id);
  }

  getVisation(id: number): void {
    this.visationService.getVisationById(id).subscribe({
      next: (visation: Visation) => {
        this.visation = visation;
        this.flattenActionsData();
      },
      error: err => {
        console.error('Error fetching visation details:', err);
        this.router.navigate(['/not-found']);
      },
    });
  }

  // Método que aplanará los datos para la tabla
  flattenActionsData(): void {
    // Accedemos a las acciones de visation directamente desde this.visation.visationActions
    this.flattenedActionsData = this.visation.visationActions.map((action: VisationAction) => ({
      id: action.id, // Mostrar el número en orden descendente
      actionName: action.action?.name, // Estado o nombre de la acción
      observation: action.observation, // Comentario u observación
      filePath: action?.filePath, // Ruta del archivo
      date: action.createdUtc,
      originalFileName: action?.originalFileName || 'Sin archivo adjunto', // Nombre original del archivo
    }));
  }

  hasDocuments(): boolean {
    return this.visation.visationActions.some(action => action.filePath);
  }

  openActionModal(action: string): void {
    let config: any;

    switch (action) {
      case 'Devolver':
        config = {
          title: 'Devolver Modificación',
          description:
            'Estás a punto de devolver esta modificación. Para continuar de click en el botón Devolver.',
          cancelButtonText: 'Cancelar',
          submitButtonText: 'Devolver',
          fields: [
            { name: 'comment', label: 'Observaciones', type: 'textarea', required: true },
            { name: 'file', label: 'Adjunta documentación', type: 'file' },
          ],
        };
        break;
      case 'Aprobar':
        config = {
          title: 'Aprobar Modificación',
          description:
            'Estás a punto de aprobar esta modificación. Para continuar de click en el botón Aprobar.',
          cancelButtonText: 'Cancelar',
          submitButtonText: 'Aprobar',
          fields: [
            { name: 'comment', label: 'Observaciones', type: 'textarea', required: true },
            { name: 'file', label: 'Adjunta documentación', type: 'file' },
          ],
        };
        break;
      case 'Rechazar':
        config = {
          title: 'Rechazar Modificación',
          description:
            'Estás a punto de rechazar esta modificación. Para continuar de click en el botón Rechazar.',
          cancelButtonText: 'Cancelar',
          submitButtonText: 'Rechazar',
          fields: [
            { name: 'comment', label: 'Observaciones', type: 'textarea', required: true },
            { name: 'file', label: 'Adjunta documentación', type: 'file' },
          ],
        };
        break;
    }

    const dialogRef = this.dialog.open(VisationModalComponent, {
      width: '400px',
      data: config,
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        const visationAction = {
          Observation: result.comment,
          FilePath: result.fileBase64, // Aquí el archivo en Base64
          Action: action,
          VisationId: this.visation.id,
          OriginalFileName: result.fileName, // Pasar el nombre original
        };

        this.visationActionService.createVisationAction(visationAction).subscribe({
          next: response => {
            console.log('VisationAction creada:', response);
            this.router.navigate(['/approval-notifications']);
          },
          error: err => {
            console.error('Error al crear VisationAction:', err);
          },
        });
      }
    });
  }

  approve(): void {
    this.openActionModal('Aprobar');
  }

  reject(): void {
    this.openActionModal('Rechazar');
  }

  return(): void {
    this.openActionModal('Devolver');
  }

  createDownloadLink(base64: string): string {
    return `data:application/octet-stream;base64,${base64}`;
  }
}
